import React from "react"
import { WorkshopImage } from "../styled/StyledWorkshopCard"

interface IWorkshopCard {
  title: string
  image?: string
}

const WorkshopCard = ({ title, image = "" }: IWorkshopCard) => {
  return (
    <>
      <WorkshopImage src={image} alt="" style={image != "" ? { width: "100%" } : { borderRadius: "5px", width: "100%" }} />
      <div className="text-center"><span style={{ fontSize: "1.5em" }}><b>{title}</b></span></div>
    </>
  )
}

export default WorkshopCard
